import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Agent = _resolveComponent("Agent")
  const _component_GradientText = _resolveComponent("GradientText")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["suggestion pointer", {hover: $data.hover, string: $options.string}]),
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('ask-ai', {text: $options.text}))),
    onMouseenter: _cache[1] || (_cache[1] = () => !$options.string && $options.onMouseEnter()),
    onMouseleave: _cache[2] || (_cache[2] = () => !$options.string && $options.onMouseLeave())
  }, [
    (!$options.string)
      ? (_openBlock(), _createBlock(_component_Agent, {
          key: 0,
          class: "agent",
          type: $props.suggestion.agent,
          open: $data.hover
        }, null, 8 /* PROPS */, ["type", "open"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_GradientText, { class: "text" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString($options.text), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    })
  ], 34 /* CLASS, NEED_HYDRATION */))
}